import React from 'react';
import styled from 'styled-components';
import { colors } from '../styles/designTokens';
import { Customer } from '../models/CustomerModels';
import { MobileTable, MobileTableHeader, MobileTableSection, MobileDetailButton } from '../styles/DashboardMobileStyles';
import { useNavigate } from 'react-router-dom';

// 모바일 고객 테이블 Props 인터페이스
interface DashboardCustomerTableMobileProps {
  customers: Customer[];
}

// 모바일 테이블 스타일 커스텀 (고객 테이블용)
const StyledMobileTable = styled(MobileTable)`
  td:nth-child(1), th:nth-child(1) { width: 25%; } // 이름
  td:nth-child(2), th:nth-child(2) { width: 20%; } // 계정 ID
  td:nth-child(3), th:nth-child(3) { width: 15%; text-align: right; } // 결제 금액
  td:nth-child(4), th:nth-child(4) { width: 15%; text-align: center; } // 전체 키워드
  td:nth-child(5), th:nth-child(5) { width: 15%; text-align: center; } // 활성 키워드
  td:nth-child(6), th:nth-child(6) { width: 10%; text-align: center; } // 상세 정보
`;

// 모바일 고객 테이블 컴포넌트
const DashboardCustomerTableMobile: React.FC<DashboardCustomerTableMobileProps> = ({ customers }) => {
  const navigate = useNavigate();

  // 숫자를 "N,NNN원" 형태로 포맷하는 함수
  const formatCurrency = (amount: number): string => {
    if (amount === 0) return '0원';
    return `${amount.toLocaleString()}원`;
  };

  // 상세 정보 버튼 클릭 핸들러
  const handleDetailClick = (userIdx: number) => {
    navigate(`/mobile/customers/${userIdx}`);
  };

  return (
    <MobileTableSection>
      <MobileTableHeader>
        <h3>고객 목록</h3>
      </MobileTableHeader>
      <StyledMobileTable>
        <thead>
          <tr>
            <th>이름</th>
            <th>사용자 ID</th>
            <th>결제금액</th>
            <th>전체 키워드</th>
            <th>활성 키워드</th>
            <th>상세</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer) => (
            <tr key={customer.user_idx}>
              <td>
                <div style={{ fontSize: '12px', fontWeight: '600' }}>
                  {customer.user_name}
                </div>
                <div style={{ fontSize: '10px', color: colors.semantic.text.tertiary, marginTop: '2px' }}>
                  {customer.user_email}
                </div>
              </td>
              <td style={{ fontSize: '11px' }}>{customer.user_id}</td>
              <td>{formatCurrency(customer.user_paid)}</td>
              <td style={{ fontSize: '11px' }}>{customer.total_keywords.toLocaleString('ko-KR')}</td>
              <td style={{ fontSize: '11px' }}>{customer.active_keywords.toLocaleString('ko-KR')}</td>
              <td>
                <MobileDetailButton onClick={() => handleDetailClick(customer.user_idx)}>
                  보기
                </MobileDetailButton>
              </td>
            </tr>
          ))}
          {(!customers || customers.length === 0) && (
            <tr>
              <td colSpan={6} style={{ textAlign: 'center', padding: '20px' }}>
                표시할 고객 데이터가 없습니다.
              </td>
            </tr>
          )}
        </tbody>
      </StyledMobileTable>
    </MobileTableSection>
  );
};

export default DashboardCustomerTableMobile; 